import type { Country } from '../../constants/country/country';
import type { Currency } from '../../constants/currency/currency';

export type AddressPrediction = {
  description: string;
  placeId: string;
  reference: string;
  types: string[];
  structuredFormatting?: Record<string, unknown>;
  terms?: unknown[];
  distanceMeters?: number;
};

export interface PostalCodeResult {
  formattedAddress: string;
  addressComponents: PostalCodeAddressComponent[];
  geometry: { lat: number; lng: number };
  placeId: string;
  types: string[];
}

export interface PostalCodeAddressComponent {
  longName: string;
  shortName: string;
  types: string[];
}

export interface AddressComponent {
  longName: string;

  shortName: string;

  types: string[];
}
